// nou style landing (?view=landing): smooth-scroll to the grid, and a phone-only sticky bar
// that appears once the hero has scrolled out of view.
(() => {
  const root = document.querySelector('[data-nou-lp]');
  if (!root) return;

  const grid = document.getElementById('lp-products');
  root.querySelectorAll('[data-lp-scroll]').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (!grid) return;
      e.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      grid.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  const hero = root.querySelector('[data-lp-hero]');
  const sticky = root.querySelector('[data-lp-sticky]');
  if (!hero || !sticky || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(([entry]) => {
    sticky.hidden = entry.isIntersecting;
  }).observe(hero);
})();
